import { Lead } from '@/api/types/crm.types'
import { FC, useState } from 'react'
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import aiclasses from '@pages/Admin/CRM/styles/activeIcon.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import { handlerDeleteStudAccount } from './deleteStudAccountModalFn'
import { useAddAlert } from '@/hooks/useAddAlert'
import { useFullLeadModalAccess } from '../../hooks/useFullLeadModalAccess'

interface TabBindingStudAccountProps {
  lead: Lead
  onOpenStudentAccount: () => void
  onOpenAddStudAccount: () => void
  onRefetchLead: () => void
}

const TabBindingStudAccount: FC<TabBindingStudAccountProps> = ({
  lead,
  onOpenStudentAccount,
  onOpenAddStudAccount,
  onRefetchLead,
}) => {
  const addAlert = useAddAlert()
  const { currentRole, ...access } = useFullLeadModalAccess()

  return (
    <div className={classes.studAccountTabWrapper}>
      {lead?.user_id ? (
        <>
          <p
            className={classes.studAccountTab}
            onClick={() => onOpenStudentAccount()}
          >
            <span>Личный каб. студента</span>
          </p>
          {access.canBindUnbindStudent && (
            <DeleteOutlined
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
              className={cn(
                aiclasses.activeIcon,
                classes.deleteStudAccountTabIcon,
              )}
              onClick={() =>
                handlerDeleteStudAccount({
                  lead,
                  addAlert,
                  onSuccess: () => onRefetchLead(),
                })
              }
            />
          )}
        </>
      ) : access.canBindUnbindStudent ? (
        <p
          className={classes.studAccountTab}
          onClick={() => onOpenAddStudAccount()}
        >
          <PlusOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
          <span>Привязать ЛК студента</span>
        </p>
      ) : null}
    </div>
  )
}

export default TabBindingStudAccount
